import styled from 'styled-components';
import React from 'react';
import { Text, Icon, Checkbox, } from '@oneaudi/unified-web-components';
import { SYS_BREAKPOINT_2_XL, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, SYS_COLOR_SURFACE_NEUTRAL_100_DARK, SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_450, SYS_SPACE_FIXED_600, SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT, } from '@oneaudi/unified-web-common';
export const ModelFilterContainer = styled.div `
  width: 100%;
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    width: ${(props) => (props.layoutWidth === '50' ? 'calc(50% - 20px)' : '100%')};
  }
`;
export const ModelFilterAccordionContainer = styled.div `
  max-width: 100%;
  width: 100%;
  display: grid;
  column-gap: ${SYS_SPACE_FIXED_300};
  grid-template-columns: repeat(2, 1fr);
  margin-bottom: ${SYS_SPACE_FIXED_450};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    position: relative;
    column-gap: ${SYS_SPACE_FIXED_600};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: ${(props) => props.layoutWidth === '100' ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)'};
    width: ${(props) => (props.layoutWidth === '50/100' ? 'calc(50% - 20px)' : '100%')};
  }
`;
export const ModelFilterAccordionSectionContent = styled.div `
  display: block;
  margin-top: -1px;
`;
export const ModelFilterAccordionSectionPanel = styled.div `
  --panel-height: 0px;
  box-sizing: border-box;
  height: var(--panel-height);
  overflow: hidden;
  visibility: ${(props) => (props.open ? 'visible' : 'hidden')};
`;
export const ModelFilterAccordionSectionPanelContent = styled.div `
  --inset: var(--spacing-relative-3xl);
  box-sizing: border-box;
  background-color: ${(props) => props.lightMode ? SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT : 'rgba(255, 255, 255, 0.15)'};
  opacity: ${(props) => (props.open ? 1 : 0)};
  position: absolute;
  left: 0;
  width: 100%;
  padding: var(--spacing-relative-xl) ${SYS_SPACE_FIXED_200} var(--spacing-relative-2xs)
    ${SYS_SPACE_FIXED_200};
  z-index: ${(props) => (props.open ? '1' : '0')};

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    padding-bottom: var(--spacing-relative-xs);
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    padding-bottom: 20px;
  }
`;
export const StyledLegend = styled.legend `
  display: flex;
  margin-block-end: ${SYS_SPACE_FIXED_300};
`;
export const AllModelsCheckbox = styled((props) => React.createElement(Checkbox, Object.assign({}, props))) `
  input {
    height: 20px !important;
  }
  margin-bottom: ${SYS_SPACE_FIXED_300};
`;
export const CarlineGroupCheckboxes = styled.div `
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  column-gap: ${SYS_SPACE_FIXED_600};
  grid-template-columns: repeat(1, 1fr);

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: ${(props) => props.layoutWidth === '100' ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)'};
  }
`;
export const StyledButton = styled.button `
  border: none 0;
  padding: 0;
  padding-bottom: ${SYS_SPACE_FIXED_300};
  background-color: ${(props) => props.open && props.lightMode
    ? SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT
    :
        props.open && !props.lightMode
            ? 'rgba(255, 255, 255, 0.15)'
            : props.lightMode
                ? '#f2f2f2'
                : '#333333'};
  width: calc(100% + 24px);
  position: relative;
  padding-left: ${(props) => (props.nthChild % 2 !== 0 ? SYS_SPACE_FIXED_200 : '0')};
  left: ${(props) => (props.nthChild % 2 !== 0 ? '-16px' : '0')};
  padding-right: ${(props) => (props.nthChild % 2 === 0 ? SYS_SPACE_FIXED_200 : '0')};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    width: 100%;
    position: static;
    padding-left: 0;
    padding-right: 0;
    left: 0;
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    background-color: ${(props) => props.open && props.lightMode
    ? SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT
    :
        props.open && !props.lightMode
            ? 'rgba(255, 255, 255, 0.15)'
            : props.lightMode
                ? SYS_COLOR_SURFACE_NEUTRAL_100_DARK
                : '#333333'};
  }

  :hover {
    cursor: pointer;

    @media (min-width: ${SYS_BREAKPOINT_LG}) {
      background-color: ${(props) => props.lightMode ? SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT : 'rgba(255, 255, 255, 0.15)'};
    }

    > img {
      scale: 1.05;
    }
  }
`;
export const TextWrapper = styled.div `
  margin-top: ${SYS_SPACE_FIXED_100};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: ${(props) => (props.nthChild % 2 === 0 ? SYS_SPACE_FIXED_200 : 0)};
  margin-right: ${(props) => (props.nthChild % 2 !== 0 ? SYS_SPACE_FIXED_200 : 0)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-left: ${SYS_SPACE_FIXED_200};
    margin-right: ${SYS_SPACE_FIXED_200};
  }
`;
export const CarlineGroupAndAmountWrapper = styled.div `
  text-align: left;
  color: var(--color-text-secondary);
`;
export const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: var(--spacing-relative-2xs);
`;
export const StyledText = styled((props) => (React.createElement(Text, Object.assign({ tag: "p", variant: {
        order: '2',
        type: 'copy',
        weight: 'normal',
    } }, props)))) `
  float: left;
`;
export const StyledImg = styled.img `
  object-fit: contain;
  width: 100%;
  height: 17.7vw;

  @media (min-width: ${SYS_BREAKPOINT_SM}px) {
    height: 18.3vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: 18.2vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: 8.2vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    height: 8.1vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    height: 162.5px;
  }
`;
export const StyledImagePlaceholder = styled.div `
  object-fit: contain;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 17.7vw;
  padding-inline-start: var(--spacing-relative-sm);
  padding-inline-end: var(--spacing-relative-sm);
  box-sizing: border-box;

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    height: 18.3vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    height: 18.2vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    height: 8.2vw;
  }
  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    height: 8.1vw;
    padding: var(--spacing-relative-md);
  }
  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    height: 162.5px;
  }

  :hover {
    cursor: pointer;

    @media (min-width: ${SYS_BREAKPOINT_LG}) {
      background-color: ${SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT};
    }
  }
`;
export const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  transform: rotateZ(${(props) => (props.open ? -180 : 0)}deg);
  color: ${SEM_COLOR_FORMS_FOREGROUND_ICONS_DEFAULT_LIGHT};
`;
export const ChosenModelsWrapper = styled.div `
  margin-top: 24px;
  padding: var(--spacing-relative-2xs) var(--spacing-relative-sm);
  display: ${(props) => (props.open ? 'none' : 'flex')};
  align-items: center;
  background-color: ${SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT};
  width: fit-content;
  margin-left: ${(props) => (props.nthChild % 2 === 0 ? SYS_SPACE_FIXED_200 : 0)};
  margin-right: ${(props) => (props.nthChild % 2 !== 0 ? SYS_SPACE_FIXED_200 : 0)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-left: ${SYS_SPACE_FIXED_200};
    margin-right: ${SYS_SPACE_FIXED_200};
  }
`;
